import { Workbox } from 'workbox-window';

function registerWorker() {
  let wb;

  if ('serviceWorker' in navigator) {
    wb = new Workbox('/service-worker.js');
    // Reload only when a NEW worker replaced an old one -- that is the case
    // where this page may hold stale chunk names. On a first visit there is
    // no old worker: service-worker.js calls skipWaiting() on install and
    // clientsClaim() on activate, so the fresh worker takes over the page it
    // was installed from and `controlling` fires with isUpdate false.
    // Reloading then threw away whatever the visitor did in their first
    // second -- measured: every fresh browser context reloaded once, about
    // 1.1 s after landing, and none did with the worker blocked.
    wb.addEventListener('controlling', event => {
      if (event.isUpdate) {
        window.location.reload();
      }
    });
    wb.register();
  } else {
    wb = null;
  }
  return wb;
}

const wb = registerWorker();

export default wb;
